import colors from '../../../config/colors'

export default {
  floatingLabelFocusStyle: { color: colors.accent },
  underlineFocusStyle: { borderColor: colors.accent },
  errorStyle: { color: colors.error },
  errorText: { color: colors.error }
}
